import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Select from "react-select";
import DeliveryForm from "./deliveryform";
import Layouts from "../../layouts/layouts";

export default function Create_clientorders() {
  const title = "Add Client Orders";
  const navigate = useNavigate();
  const location = useLocation();
  const brad = [{ name: "Home" }, { name: title }];

  // State for form data and errors
  const [formData, setFormData] = useState({
    client_id: "",
    hub_id: "",
    delivery_date: new Date().toISOString().split("T")[0], // Default to today
  });

  const [errors, setErrors] = useState({});
  const [clients, setClients] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [deliveries, setDeliveries] = useState([]);

  // Populate form if orderData exists in location.state
  useEffect(() => {
    if (location.state?.orderData) {
      const { client_id, hub_id, delivery_date, delivery_information } =
        location.state.orderData;

      setFormData({
        client_id,
        hub_id,
        delivery_date,
      });

      setDeliveries(delivery_information || []);
    }
  }, [location.state]);

  const handleDeliveryDataChange = (data) => {
    setDeliveries(data);
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.delivery_date)
      newErrors.delivery_date = "Delivery Date is required";
    if (!formData.client_id) newErrors.client_id = "Client is required";
    if (!formData.hub_id) newErrors.hub_id = "Hub is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const sanitizedDeliveries = deliveries.map(
      ({ autocomplete, ...rest }) => rest
    );

    const orderData = {
      client_id: formData.client_id,
      hub_id: formData.hub_id,
      delivery_date: formData.delivery_date,
      delivery_information: sanitizedDeliveries,
    };

    navigate("/mymapcomponentorder", {
      state: { orderData },
    });
  };

  useEffect(() => {
    const fetchData = async (type) => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");
        if (!token) throw new Error("No token found");

        let apiUrl;
        if (type === "clients") {
          apiUrl =
            userRole === "superadmin"
              ? `${process.env.REACT_APP_BASE_URL}/api/v1/clients`
              : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/${userRole}/clients`;
        } else {
          apiUrl =
            userRole === "superadmin"
              ? `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`
              : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/${userRole}/hubs`;
        }

        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (type === "clients") {
          const clientList = response.data.clients || [];
          setClients(clientList);

          // ✅ Auto-select if only one client
          if (clientList.length === 1) {
            setFormData((prev) => ({
              ...prev,
              client_id: clientList[0]._id,
            }));
          }
        } else {
          const hubList = response.data.hubs || [];
          setHubs(hubList);

          // ✅ Auto-select if only one hub
          if (hubList.length === 1) {
            setFormData((prev) => ({
              ...prev,
              hub_id: hubList[0]._id,
            }));
          }
        }
      } catch (error) {
        console.error(`Error fetching ${type}:`, error);
      }
    };

    fetchData("clients");
    fetchData("hubs");
  }, []);

  // useEffect(() => {
  //   const fetchData = async (type) => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       const userRole = localStorage.getItem("userRole");
  //       if (!token) throw new Error("No token found");
  //       let apiUrl;
  //       if (type === "clients") {
  //         apiUrl =
  //           userRole === "superadmin"
  //             ? `${process.env.REACT_APP_BASE_URL}/api/v1/clients`
  //             : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/${userRole}/clients`;
  //       } else {
  //         apiUrl =
  //           userRole === "superadmin"
  //             ? `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`
  //             : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/${userRole}/hubs`;
  //       }

  //       const response = await axios.get(apiUrl, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });

  //       if (type === "clients") setClients(response.data.clients || []);
  //       else setHubs(response.data.hubs || []);
  //     } catch (error) {
  //       console.error(`Error fetching ${type}:`, error);
  //     }
  //   };

  //   fetchData("clients");
  //   fetchData("hubs");
  // }, []);

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div>{title}</div>
            <button
              className="btn btn-info btn-sm"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6 mt-3">
                <label>
                  <b>Client *</b>
                </label>
                <Select
                  options={clients.map((client) => ({
                    value: client._id,
                    label: client.name,
                  }))}
                  value={
                    clients.find((c) => c._id === formData.client_id)
                      ? {
                          value: formData.client_id,
                          label: clients.find(
                            (c) => c._id === formData.client_id
                          )?.name,
                        }
                      : null
                  }
                  onChange={(e) =>
                    setFormData({ ...formData, client_id: e.value })
                  }
                />
                {errors.client_id && (
                  <p className="text-danger">{errors.client_id}</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label>
                  <b>Location *</b>
                </label>
                <Select
                  options={hubs.map((hub) => ({
                    value: hub._id,
                    label: hub.address,
                  }))}
                  value={
                    hubs.find((h) => h._id === formData.hub_id)
                      ? {
                          value: formData.hub_id,
                          label: hubs.find((h) => h._id === formData.hub_id)
                            ?.address,
                        }
                      : null
                  }
                  onChange={(e) =>
                    setFormData({ ...formData, hub_id: e.value })
                  }
                />
                {errors.hub_id && (
                  <p className="text-danger">{errors.hub_id}</p>
                )}
              </div>

              <div className="col-md-6 mt-6">
                <label>
                  <b>Delivery Date *</b>
                </label>
                {/* <input
                  type="date"
                  name="delivery_date"
                  onChange={onChangeHandler}
                  className="form-control"
                  value={formData.delivery_date}
                /> */}
                <input
                  type="date"
                  name="delivery_date"
                  onChange={onChangeHandler}
                  className="form-control"
                  value={formData.delivery_date}
                  min={new Date().toISOString().split("T")[0]} // 👈 Sets today as the minimum
                />

                {errors.delivery_date && (
                  <p className="text-danger">{errors.delivery_date}</p>
                )}
              </div>

              <div className="col-md-6 mt-3"></div>

              <div className="col-md-12 mt-3">
                <h5>
                  <b>Order Details *</b>
                </h5>
                <DeliveryForm
                  onDeliveryDataChange={handleDeliveryDataChange}
                  initialData={deliveries} // Pass existing delivery data
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Orders
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
